import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import ReactCrop from "react-image-crop";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import {useDropzone} from "react-dropzone";
import React, {useCallback, useState} from "react";
import {config} from "../../../constant";

import 'react-image-crop/dist/ReactCrop.css';

export default function DialogImageUpload({open, onClose, id}) {
  const [src, setSrc] = useState(null);
  const [imageRef, setImageRef] = useState();
  const [fileName, setFileName] = useState(null);
  const [croppedImageData, setCroppedImageData] = useState(null);
  const [crop, setCrop] = useState({
    unit: "%",
    width: 30,
    aspect: 1
  });

  const onImageLoaded = (image) => {
    setImageRef(image);
  };

  const onCropComplete = (crop) => {
    makeClientCrop(crop);
  };

  const onCropChange = (crop, percentCrop) => {
    setCrop(crop);
  };

  const makeClientCrop = (crop) => {
    if (imageRef && crop.width && crop.height) {
      const croppedImageData = getCroppedImg(imageRef, crop);
      setCroppedImageData(croppedImageData);
    }
  };

  const getCroppedImg = (image, crop) => {
    const canvas = document.createElement('canvas');
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY
    );

    const base64Image = canvas.toDataURL('image/jpeg');
    return base64Image.split(',')[1];
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      setFileName(file.name);
      const reader = new FileReader();

      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        setSrc(reader.result);
      };
      reader.readAsDataURL(file);
      // reader.readAsArrayBuffer(file)
    })
  }, []);

  const {getRootProps, getInputProps} = useDropzone({onDrop});

  const save = () => {
    if (croppedImageData) {
      const image = {
        name : fileName,
        contentType : 'image/png',
        data : croppedImageData
      };

      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(image)
      };
      fetch(`${config.BASE_URL}/images/person/${id}`, requestOptions)
          .then(response => response.json())
          .then(data => {
            console.log('Sauvegarde image OK');
            // setAvatarData(image.data);
            // reset();
            onClose(data);
          });
    }
  };

  // const reset = () => {
  //   setSrc(null);
  //   setImageRef(null)
  //   setFileName(null);
  //   setCroppedImageData(null);
  // };

  return (
      <Dialog open={open} onClose={() => onClose(null)}>
        <DialogTitle>Avatar</DialogTitle>
        <DialogContent>
          <Box {...getRootProps()} sx={{
            textAlign: 'center',
            padding: '20px',
            border: '3px dashed #eeeeee',
            backgroundColor: '#fafafa',
            color: '#bdbdbd',
            marginBottom: '20px'
          }}>
            <input {...getInputProps()} />
            <p>Cliquez ici ou faites glisser votre image</p>
          </Box>
          {/*<div {...getRootProps({className: 'dropzone'})}>*/}
          {/*  <input {...getInputProps()} />*/}
          {/*  <p>Cliquez ici ou faites glisser votre image</p>*/}
          {/*</div>*/}
          {src && (
              <ReactCrop src={src} crop={crop} ruleOfThirds onImageLoaded={onImageLoaded} onComplete={onCropComplete} onChange={onCropChange} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={save}>OK</Button>
          <Button onClick={() => onClose(null)}>Annuler</Button>
        </DialogActions>
      </Dialog>
  );
}
